import {Fragment} from "preact";
import {legacySatisfactionSurveyImg} from "../../../assets";
import s from "./content.module.css";
import {useAppContext} from "../../../contexts";

const Content = (props) => {
    // Destructured props
    const {
        setOpen,
        urlPath
    } = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    return (
        <Fragment>
            <img
                src={legacySatisfactionSurveyImg}
                alt="Satisfaction survey image"
                className={`${s.img} ${highContrast ? "filter grayscale" : ""}`}
            />
            <div>
                <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                    <button
                        type="button"
                        className={`font-museo ${s.closeButton} ${highContrast ? "text-white" : "text-black"}`}
                        onClick={() => setOpen(false)}
                    >
                        <span className="sr-only">
                            Fechar
                        </span>
                        x
                    </button>
                </div>
                <div className="mt-5">
                    <p className={`font-museo ${s.leading} ${highContrast ? "text-white" : "text-black"}`}>
                        Que tal avaliar sua experiência
                        com a Loja Virtual Sabin?
                    </p>
                </div>
                <div className="mt-3">
                    <a
                        href={urlPath || "#"}
                        target={"_blank"}
                        rel={"noreferrer"}
                        className={`${s.actionButton} ${highContrast ? "highFormButton" : ""}`}
                        onClick={() => setOpen(false)}
                    >
                        CLIQUE AQUI E AVALIE&nbsp;
                        <p className={"leading-none"}>
                            →
                        </p>
                    </a>
                </div>
            </div>
        </Fragment>
    )
}

export default Content;
